module.exports = __webpack_public_path__ + "static/media/star-black.9a19941e.svg";